import React from "react";
import { Button, MenuButton, MenuList, Menu, MenuItem } from "@chakra-ui/react";
import { NavLink, useLocation } from "react-router-dom";

interface MenuLink {
  path: string;
  label: string;
  hasRight?: boolean;
}

interface DropdownProps {
  menuLinks: MenuLink[];
  title: string;
}

const MENU_THEME = {
  DARK: "dark",
  WEWAK: "wewak",
  WHITE: "white",
} as const;

const hoverStyle = {
  color: MENU_THEME.WEWAK,
  py: "1.6rem",
  borderBottom: "2px",
} as const;

export const MenuDropdown: React.FC<DropdownProps> = ({ menuLinks, title }) => {
  const { pathname } = useLocation();

  const isActive = menuLinks.some((link) => pathname === link.path);

  return (
    <Menu>
      <MenuButton
        data-testid="dropdown-button"
        fontSize="xs"
        borderRadius="0"
        color={isActive ? "sunglo" : MENU_THEME.WHITE}
        borderBottom="2px"
        borderColor={isActive ? "initial" : "transparent"}
        height="100%"
        variant=""
        fontWeight="bold"
        textDecoration="none"
        py="25px"
        px="17px"
        _hover={hoverStyle}
        _focus={hoverStyle}
        as={Button}
      >
        {title}
      </MenuButton>
      <MenuList bg={MENU_THEME.DARK} borderColor="none">
        {menuLinks.map(
          (link) =>
            (link?.hasRight === undefined || link?.hasRight) && (
              <MenuItem
                as={NavLink}
                to={link.path}
                key={link.path}
                fontWeight="medium"
                color="white"
                bg={MENU_THEME.DARK}
                _focus={{
                  bg: MENU_THEME.DARK,
                }}
                _hover={{ bg: MENU_THEME.DARK, color: MENU_THEME.WEWAK }}
              >
                {link.label}
              </MenuItem>
            )
        )}
      </MenuList>
    </Menu>
  );
};

export default MenuDropdown;
